import React, { useState } from 'react';

const ChallengePasswordForm = ({ username, onSubmit, onCancel }) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (password.length < 12) {
      setError('Use at least 12 characters, with upper, lower, number, and symbol.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setBusy(true);
    setError('');
    try {
      await onSubmit(password);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="login-form">
      <p className="muted">Set a permanent password for {username}.</p>
      <label htmlFor="new-password">New password</label>
      <input
        id="new-password"
        type="password"
        value={password}
        onChange={(event) => setPassword(event.target.value)}
        required
        autoComplete="new-password"
      />
      <label htmlFor="confirm-password">Confirm password</label>
      <input
        id="confirm-password"
        type="password"
        value={confirm}
        onChange={(event) => setConfirm(event.target.value)}
        required
        autoComplete="new-password"
      />
      {error && <div className="error-box" role="alert">{error}</div>}
      <button className="primary-button" type="submit" disabled={busy}>
        {busy ? 'Saving...' : 'Save password'} <span aria-hidden="true">↗</span>
      </button>
      <button className="ghost-button" type="button" onClick={onCancel}>
        Back to sign in
      </button>
    </form>
  );
};

export default ChallengePasswordForm;
